module.exports = __webpack_public_path__ + "images/fbplus.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/fancybox-plus/images/fbplus/fbplus.png
// module id = 41
// module chunks = 0